import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const ReviewsSectionLoadingState: React.FC = () => {
  return (
    <Box paddingTop="s600">
      <SkeletonLoader width={100} />
      <SkeletonLoader width={200} />
    </Box>
  )
}
